import { execute } from '@/api/execute'
import { GET } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'history/farms'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  }
}
